module.exports = __webpack_public_path__ + "img/welfare-mycb02.3011fabb.png";